if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => ShopifyThemeReset());
  document.addEventListener('shopify:section:reorder', () => ShopifyThemeReset());
}

init();

function init() {
  var productGrid = document.querySelector('#product-grid');
  var products = [...productGrid.querySelectorAll('li')];
  var ads = [...document.querySelectorAll('.collection-ad')];

  if (!productGrid) { return; }

  ads.forEach((ad) => {
    var position = Number(ad.getAttribute('data-position'));
    moveAd(ad, position, products);
  });
}

function moveAd(ad, position, products) {
  if (position === 0 || !position) {
    return;
  }

  if (products.length < position) {
    ad.remove();
    return;
  }

  products.forEach((product, index) => {
    index += 1;
    
    if (position === index) {
      ad.style.display = 'block';
      product.parentNode.insertBefore(ad, product);
    }
  })
}

function ShopifyThemeReset() {
  var productGrid = document.querySelector('#product-grid');
  var ads = [...productGrid.querySelectorAll('.collection-ad')];

  if (!productGrid) { return; }

  ads.forEach((ad) => {
    ad.remove();
  });
};
